import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class QuerySamplingCta extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      helpers: {
        enableQuerySampling: () => this.dispatchEvent(new CustomEvent(`enable`)),
      },
    };
  }
}

export const QuerySamplingCtaEl = defineAndMakeJsxFactory(`mp-query-sampling-cta`, QuerySamplingCta);
